import { inviteUserService, getLaboratoryUsersList, editLaboratoryUser, removeLaboratoryUser } from './UserServices';
export type { IInviteUserRequst } from './IUserServices';

export const UserServices = { inviteUserService, getLaboratoryUsersList, editLaboratoryUser, removeLaboratoryUser };
